


















































import { Component, Prop, Watch, Vue } from "vue-property-decorator";
import { Auth } from '@aws-amplify/auth';
import * as rules from '@/rules';
import _ from "lodash";
import ChoiceInputFormRecursiveGroup from "@/components/choice-input/form/ChoiceInputFormRecursiveGroup.vue";
import { VIEWPOINT_API } from "@/api/ViewpointApi";
import { Factor, FactorGroup, FactorResource } from "@/api/model/FactorResource";
import { ViewpointFactorResource } from "@/api/model/ViewpointFactorResource";
import Choices from "@/store/modules/Choices";
import Sticky from 'vue-sticky-directive';
import { getModule } from "vuex-module-decorators";
import ImagePicker from "@/components/common/ImagePicker.vue";
import ChoiceInputForm from "@/components/choice-input/form/ChoiceInputForm.vue";
import QuestionnaireChoiceInput from "@/components/choice-input/questionnaire/QuestionnaireChoiceInput.vue";
import { ChoiceInputFactorResource } from "@/types/ChoiceInputFactorResource";

const choicesModule = getModule(Choices);

@Component({
    components: {
        QuestionnaireChoiceInput,
        ChoiceInputForm,
        ChoiceInputFormRecursiveGroup,
        ImagePicker
    },
    directives: {Sticky},
})
export default class ChoiceForm extends Vue {

    @Prop()
    private formId!: string;

    private modelFactorResources: { [id: string]: ChoiceInputFactorResource } | null = null
    private choiceForm: any = {};
    private submitting = false;
    private createdChoiceId = '';
    private name = '';
    private description = ''
    private choiceId = '';
    private viewType: 'FORM' | 'QUESTIONNAIRE' = 'FORM';
    private styles: any = {};

    mounted() {
        this.init();
    }

    private rules = {
        required: rules.REQUIRED,
    }

    get loading() {
        return !this.modelFactorResources;
    }

    get isDisabled() {
        if (this.choiceForm.name) {
            return false;
        }
        return true;
    }

    @Watch('loading')
    onLoadingChange() {
        setTimeout( () => window.scrollBy(0,  1), 100 );
        setTimeout( () => window.scrollBy(0, -1), 200 );
    }

    private async init() {
        await Auth.currentCredentials();

        let choiceInputInformation = await VIEWPOINT_API.getForm(this.formId);
        this.name = choiceInputInformation.name;
        this.description = choiceInputInformation.description
        this.choiceId = choiceInputInformation.choiceId
        this.viewType = choiceInputInformation.viewType || 'FORM';
        this.styles = choiceInputInformation.styling || {};
        this.setStyles();

        if (choiceInputInformation.choice) {
            this.choiceForm = choiceInputInformation.choice
        }

        let modelFactorResources: { [id: string]: ChoiceInputFactorResource } = _.keyBy(choiceInputInformation.factorResources, 'id');
        let viewpointFactors: { [viewpointId: string]: ViewpointFactorResource[] } = choiceInputInformation.viewpointsFactorResources
        let mappedViewpointFactors: { [viewpointId: string]: { [id: string]: ViewpointFactorResource } } = {};
        for (let viewpointId of Object.keys(viewpointFactors)) {
            mappedViewpointFactors[viewpointId] = _.keyBy(viewpointFactors[viewpointId], 'id');
        }

        this.updateWeights(modelFactorResources, mappedViewpointFactors);
        // This add the visibility definition for displaying parts of the form dependent on if other parts are filled out
        if (Object.keys(viewpointFactors).length === 1) {
            Object.values(viewpointFactors)[0]
                .filter(vf => vf.visibilityDefinition && modelFactorResources[vf.id])
                .forEach(vf => modelFactorResources[vf.id].visibilityDefinition = vf.visibilityDefinition)
        }
        this.modelFactorResources = modelFactorResources;
    }

    private setStyles() {
        const app: any = document.getElementById('app');
        const backgroundColor: string = this.styles.backgroundColor || '';
        if (app) {
            if (this.styles.backgroundColor) {
                app.style.background = this.styles.backgroundColor;
                app.style.backgroundColor = this.styles.backgroundColor;
                document.body.style.background = this.styles.backgroundColor;
                document.body.style.backgroundColor = this.styles.backgroundColor;
                document.documentElement.style.background = this.styles.backgroundColor;
                document.documentElement.style.backgroundColor = this.styles.backgroundColor;
            }
        }
        const header: any = document.querySelector('.account-menu__button');
        if (header) {
            header.style.display = 'none';
        }
    }

    private updateWeights(modelFactorResources: { [p: string]: FactorResource }, mappedViewpointFactors: { [p: string]: { [p: string]: ViewpointFactorResource } }) {
        this.updateGroupWeight('M', modelFactorResources, mappedViewpointFactors);
    }

    private updateGroupWeight(id: string, modelFactorResources: { [p: string]: FactorResource }, mappedViewpointFactors: { [p: string]: { [p: string]: ViewpointFactorResource } }) {
        let factorResource = modelFactorResources[id] as FactorGroup;
        let groupNumDots = 0;
        for (let child of factorResource.childrenIds) {
            let childFactorResource = modelFactorResources[child];
            if (!childFactorResource) continue;
            if (childFactorResource.type === 'FACTOR') {
                let factorWeight = ChoiceForm.getNumWeightingDots(childFactorResource as Factor, mappedViewpointFactors);
                modelFactorResources[child].numWeightingDots = factorWeight
                groupNumDots += factorWeight
            } else if ((childFactorResource as FactorGroup).groupTypeDefinition && (childFactorResource as FactorGroup).groupTypeDefinition === 'TABLE_ROW') {
                this.updateGroupWeight(child, modelFactorResources, mappedViewpointFactors);
            } else {
                groupNumDots += this.updateGroupWeight(child, modelFactorResources, mappedViewpointFactors)
            }
        }
        modelFactorResources[id].numWeightingDots = groupNumDots;

        return groupNumDots;
    }

    private static getNumWeightingDots(factor: Factor, mappedViewpointFactors: { [p: string]: { [p: string]: ViewpointFactorResource } }) {
        let viewpointIds = Object.keys(mappedViewpointFactors);
        if (viewpointIds.length === 0) return factor.numWeightingDots || 0;
        let viewpointFactors = viewpointIds.map(vId => mappedViewpointFactors[vId][factor.id])
            .filter(f => f);
        let zeroFound = false;
        for (let vpF of viewpointFactors) {
            if (vpF.numWeightingDots == undefined || vpF.numWeightingDots > 0) {
                return vpF.numWeightingDots || 1
            }
            zeroFound = true;
        }

        if (zeroFound) return 0;
        return factor.numWeightingDots || 0

    }

    private async submitChoice() {
        this.submitting = true;
        let choice = Choices.cleanseChoiceData(this.choiceForm);
        if (this.createdChoiceId) {
            choice.id = this.createdChoiceId
        }
        let createdChoice = await VIEWPOINT_API.submitFormData(this.formId, choice);
        this.createdChoiceId = createdChoice.id;
        this.submitting = false;
    }

}
